import { Tooltip } from 'antd';
import './styles.css';

export const formatCurrency = (val, round = false) => {
  val = Number(val || 0);
  if (round) {
    val = Math.round(val);
  }
  return val.toLocaleString('en-IN', {
    minimumFractionDigits: round ? 0 : 2,
    maximumFractionDigits: round ? 0 : 2,
  });
};

export const renderWithEllipsis = (text, { width = 180, lines = 1 } = {}) => {
  if (!text) return <span className="util-text-muted">—</span>;

  return (
    <Tooltip title={text}>
      <div
        className="util-ellipsis"
        data-lines={lines}
        data-width={typeof width === 'number' ? `${width}px` : width}
      >
        {text}
      </div>
    </Tooltip>
  );
};

export const uniqueValues = (data, key, nestedKey = null) =>
  Array.from(
    new Set(
      data.map((record) => (nestedKey ? record[key]?.[nestedKey] : record[key])).filter(Boolean),
    ),
  ).sort();
